import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { loadDeploymentConfig } from './services/dataProvider';
import { setChatTheme } from './helpers/themeUtils';
import { addEventListener, removeEventListener, EVENT_TYPES } from './helpers/eventManager';

loadDeploymentConfig()
    .then(() => {
        const root = ReactDOM.createRoot(document.getElementById('root'));
        root.render(
            //<React.StrictMode>
            <App />
            //</React.StrictMode>
        );

        window.setChatTheme = setChatTheme;

        window.rdmWindowVisible = true;

        if (window.chrome?.webview) {
            window.chrome.webview.addEventListener('message', (event) => {
                if (event.data && event.data.type === 'RDM_VISIBILITY_CHANGED') {
                    const wasVisible = window.rdmWindowVisible;
                    const newVisibility = event.data.visible === true;
                    
                    window.rdmWindowVisible = newVisibility;
                    
                    if (wasVisible !== newVisibility) {
                        const visibilityEvent = new CustomEvent('rdmVisibilityChanged', {
                            detail: { visible: window.rdmWindowVisible }
                        });
                        window.dispatchEvent(visibilityEvent);
                    }
                }
            });

            const rdmHandlers = [];

            // Forward all new messages (agent, user, chatbot, typing indicators)
            const messageHandler = (data) => {
                try {
                    window.chrome.webview.postMessage({
                        type: 'CHATBOT_MESSAGE',
                        payload: data
                    });
                } catch (error) {
                    console.error('[RDM] Failed to send message to WebView2:', error);
                }
            };
            addEventListener(EVENT_TYPES.ON_NEW_MESSAGE, messageHandler);
            rdmHandlers.push({ type: EVENT_TYPES.ON_NEW_MESSAGE, handler: messageHandler });

            // Forward agent left events
            const agentLeftHandler = (data) => {
                try {
                    window.chrome.webview.postMessage({
                        type: 'CHATBOT_AGENT_LEFT',
                        payload: data
                    });
                } catch (error) {
                    console.error('[RDM] Failed to send agent left event to WebView2:', error);
                }
            };
            addEventListener(EVENT_TYPES.ON_AGENT_LEFT, agentLeftHandler);
            rdmHandlers.push({ type: EVENT_TYPES.ON_AGENT_LEFT, handler: agentLeftHandler });

            // Forward conversation closed events
            const closeHandler = (data) => {
                try {
                    window.chrome.webview.postMessage({
                        type: 'CHATBOT_CONVERSATION_CLOSED',
                        payload: data
                    });
                } catch (error) {
                    console.error('[RDM] Failed to send close event to WebView2:', error);
                }
            };
            addEventListener(EVENT_TYPES.ON_CLOSE, closeHandler);
            rdmHandlers.push({ type: EVENT_TYPES.ON_CLOSE, handler: closeHandler });

            // Cleanup on page unload to prevent memory leaks
            window.addEventListener('beforeunload', () => {
                rdmHandlers.forEach(({ type, handler }) => {
                    removeEventListener(type, handler);
                });
            });
        }

    })
    .catch((error) => {
        console.error('Impossible de démarrer l\'application : configuration externe manquante.', error);
    });
